<!-- 首页-教学中心模块 -->
<template>
  <div class="teaching-ai-content">
    <homeModuleHead :apply="apply" @toTeaching="toTeaching"></homeModuleHead>

    <div class="teaching-center">
      <div class="teaching-center-left">
        <img src="../../../public/images/home/teachingCenter.png" alt="">
        <div class="outer-border"></div>
      </div>
      <div class="teaching-center-right">
        <div class="outer-border"></div>
        <div class="right-teaching">
          <div class="teach">
            <div class="teach-left">
              <span class="icon-teach"></span>
              <span>教</span>
            </div>
            <div class="teach-right">
              <h6>AI教学质量全面提升</h6>
              <p>课前准备 / 课中互动 / 课后评价</p>
              <h6>AI教学资源共建共享</h6>
              <p>资源制作 / 资源展示 / 资源管理</p>
            </div>
          </div>
          <div class="learn">
            <div class="teach-left">
              <span class="icon-teach"></span>
              <span>学</span>
            </div>
            <div class="teach-right">
              <p>在线学习 / 在线作业 / 在线考试</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  teaching1,
  teaching2,
  teaching3,
  teaching4,
  teaching5,
  teaching6,
  teaching7,
  teaching8,
  teaching9,
  teaching10
} from "@/utils/images.js";
import { mapGetters } from "vuex";

import homeModuleHead from './HomeModuleHead.vue' // 头部

export default {
  name: "teaching",
  components: {homeModuleHead},
  props: {},

  data() {
    return {
      teaching1,
      teaching2,
      teaching3, 
      teaching4,
      teaching5,
      teaching6,
      teaching7,
      teaching8,
      teaching9,
      teaching10,
      apply: {
        titleEnglish: ['THE', 'TEACHING CENTER'],
        title: '教学中心',
        intro: "辅教+助学，让AI教学更简单",
        more: "开始教学",
        redirect: "",
        openUrl: "teaching"
      },
    };
  },
  computed: {
    ...mapGetters(['token','userRole','appId', 'smsUrl', 'smsPath','teachingCourseId'])
  },
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    goToExperienceAi() {
    },
    toTeaching(){
      let {token,userRole, appId, smsUrl, smsPath} =this;
      let courseId = this.teachingCourseId;

      if(sessionStorage.token){
        token = sessionStorage.token.replace(/"/g, "");
      }else {
        this.$router.push({ name: "teaching-center-code" });
        return
      }
      if (userRole != 2) { //教师用户
        let targetUrl = smsUrl + "?token=" + token + "&appId=" + appId + "&redirect=" + smsPath + "?courseId=" + courseId;
        console.log("targetUrl", targetUrl);
        window.open(targetUrl);
      } else {//学生用户

        this.$router.push({ name: "teaching-center-code" });
      }
    },
  },

  destroyed() {
  },
  activated() {
  }
};
</script>
<style lang="scss" scoped>
%flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

%flex-start {
  display: flex;
  justify-content: start;
  align-items: center;
}

%flex-bewteen {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::v-deep .el-divider--horizontal {
  width: 45px;
  background: rgba(0, 0, 0, 0.67);
  opacity: 0.6;
}
div {
  box-sizing: border-box;
}

.teaching-ai-content {
  width: 100%;
  // height: 100%;
  background-color: #24244E;
  // height: 900px;
  // background: url(../../../public/images/home/teaching/teaching-bg.png) no-repeat;
  // background-size: 100% 100%;

  .teaching-center {
    width: 1200px;
    height: 690px;
    margin: 0 auto;
    padding: 100px 0;
    display: flex;

    .teaching-center-left {
      flex: 1;
      position: relative;
      .outer-border {
        width: 469px;
        height: 298px;
        background: url("../../../public/images/home/teaching-outer-frame01.png") no-repeat;
        background-size: contain;
        position: absolute;
        left: 0;
        bottom: 0;
      }
      img {
        width: 498px;
        height: 402px;
        position: absolute;
        left: 42px;
        bottom: 40px;
      }
    }
    .teaching-center-right {
      flex: 1;
      position: relative;
      .outer-border {
        width: 469px;
        height: 298px;
        background: url("../../../public/images/home/teaching-outer-frame02.png") no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        right: 0;
      }
      .right-teaching {
        position: absolute;
        top: 100px;
        right: 80px;
        .teach {
          width: 465px;
          height: 146px;
          background: #222854;
          border: 1px solid #c3b8b865;
          border-radius: 73px;
          display: flex;
          .teach-left {
            width: 150px;
            height: 145px;
            background: #0A9BD6;
            border-radius: 93px 0px 97px 93px;
            font-size: 48px;
            color: #FFFFFF;
            text-shadow: 0px 1px 1px #000000;
            line-height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;

            .icon-teach {
              width: 63px;
              height: 54px;
              background: url("../../../public/images/home/icon-teach.png") no-repeat;
              background-size: 100% 100%;
              margin-right: 3px;
            }
          }
          .teach-right {
            flex: 1;
            color: #FFFFFF;
            font-size: 18px;
            text-shadow: 0px 1px 1px #000000;
            text-align: left;
            margin-left: 10px;
            h6 {
              font-size: 20px;
              font-weight: bold;
            }
            h6,
            p {
              margin-top: 8px;
            }
          }
        }
        .learn {
          width: 415px;
          height: 107px;
          // background: rgba(32, 45, 93, 0.68);
          border: 1px solid #c3b8b865;
          border-radius: 53px;
          background: #222854;
          margin: 43px auto 0;
          display: flex;
          .teach-left {
            width: 114px;
            height: 106px;
            background: #0A9BD6;
            border-radius: 53px 0px 59px 53px;
            font-size: 38px;
            color: #FFFFFF;
            text-shadow: 0px 1px 1px #000000;
            line-height: 38px;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon-teach {
              width: 46px;
              height: 41px;
              background: url("../../../public/images/home/icon-learn.png") no-repeat;
              background-size: 100% 100%;
              margin-right: 5px;
            }
          }
          .teach-right {
            flex: 1;
            color: #FFFFFF;
            font-size: 18px;
            text-shadow: 0px 1px 1px #000000;
            text-align: left;
            margin-left: 20px;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
